export default __webpack_public_path__ + "static/media/png.22d2bebc.png";